// Lightweight account / sign-in state layered over the persistent account handle (the id the
// server wallet keys on, via economy.getHandle). There is NO password / real auth yet — security
// (hashing, sessions) is a separate, server-authoritative concern; register & login here simply
// CHOOSE the handle the account endpoints use, and a signed-in flag gates the pre-game landing.
// Purely frontend / localStorage, flag-agnostic, never touches the sim or match path.

import { getHandle, setToken } from '../services/JKGame_economy'

const HANDLE_KEY = 'jkgame.handle' // the key economy.getHandle reads
const SIGNED_KEY = 'jkgame.signedIn'
const NAME_KEY = 'jkgame.displayName'

export function isSignedIn(): boolean {
  try {
    return localStorage.getItem(SIGNED_KEY) === '1'
  } catch {
    return false
  }
}

/** The current account handle (generates a guest one on first use, per economy.getHandle). */
export function currentHandle(): string {
  return getHandle()
}

export function displayName(): string {
  try {
    return localStorage.getItem(NAME_KEY) || ''
  } catch {
    return ''
  }
}

/** A valid handle: 3–20 chars of letters / digits / underscore / hyphen (an account id, not a
 *  free-text display name). Keeps it URL-safe for the `/account/{handle}/*` endpoints. */
export function validateHandle(h: string): boolean {
  return /^[A-Za-z0-9_-]{3,20}$/.test(h)
}

/** Persist the signed-in account: the (server-normalized) handle, a session token, and an
 *  optional display name, then mark signed-in so the landing isn't shown again until sign-out.
 *  The token authenticates every subsequent account call (X-JK-Token). */
export function signIn(handle: string, token: string, name = ''): void {
  setToken(token)
  try {
    localStorage.setItem(HANDLE_KEY, handle)
    if (name) localStorage.setItem(NAME_KEY, name)
    else localStorage.removeItem(NAME_KEY)
    localStorage.setItem(SIGNED_KEY, '1')
  } catch {
    /* ignore */
  }
}

/** Continue as guest: keep (or generate) the auto handle and mark signed-in. */
export function continueAsGuest(): void {
  getHandle() // ensure a handle exists
  try {
    localStorage.setItem(SIGNED_KEY, '1')
  } catch {
    /* ignore */
  }
}

/** Sign out: clear the session token + signed-in flag (the landing shows again next launch).
 *  Keeps the handle/wallet on this device. */
export function signOut(): void {
  setToken('')
  try {
    localStorage.removeItem(SIGNED_KEY)
  } catch {
    /* ignore */
  }
}
